module.exports = __webpack_public_path__ + "media/src/images/icon__happy--5--dark-cc837043a2a4a5c4828a09e7e7d6efcf.png";